export default __webpack_public_path__ + "static/media/wallet_balance.38b55444.png";